import {
  Typography,
  Paper,
  CardHeader,
  IconAvatar,
  FilterNoneOutlinedIcon,
} from '@occc/ui-design-system';
import { Switches } from '@occc-app/design-system';

type StackableProps = {
  disabled?: boolean;
};

export const Stackable = ({ disabled = false }: StackableProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Offer Stacking</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Allow other offers to stack with this offer. The other offers must also be configured to
          be stackable.
        </Typography>
      }
      action={<Switches name='stackable' data={{ disabled }} />}
      avatar={<IconAvatar Icon={FilterNoneOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
